import { useState } from 'react';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';

import JaberAlkhawaterLogo from '../assets/jaber-alkhawater-logo.png';
import { cdnImage } from '@/lib/cdn';

const RegisterComponent = () => {
	const [registerFormData, setRegisterFormData] = useState({
		email: '',
		passwrd: 'NA',
		firstname: '',
		lastname: '',
		phone: '',
		address: 'NA',
		status: 'REGISTERED',
		role: 'USER',
		subscription_by: 'NA',
		level: '3 ثانوي',
		branch: 'آداب وفلسفة',
	});

	const [registerBtnText, setRegisterBtnText] = useState('إرسال التسجيل');
	const [isShowRegisterConfirmDialog, setIsShowRegisterConfirmDialog] = useState(false);
	const [isShowRegisterErrorDialog, setIsShowRegisterErrorDialog] = useState(false);
	const [isStartRegister, setIsStartRegister] = useState(false);
	const [paymentReceivedContentFile, setPaymentReceivedContentFile] = useState(null);
	const handlePaymentReceivedContentChange = (e: any) => {
		setPaymentReceivedContentFile(e.target.files[0]);
	};

	const handleRegisterSubmit = async (e: React.FormEvent) => {
		e.preventDefault();

		try {
			setRegisterBtnText('جاري التسجيل ...');
			setIsStartRegister(true);

			if (!paymentReceivedContentFile) {
				setRegisterBtnText('إرسال التسجيل');
				setIsStartRegister(false);
				return;
			}
			const formData = new FormData();
			formData.append('file', paymentReceivedContentFile);

			formData.append('email', registerFormData.email);
			formData.append('firstname', registerFormData.firstname);
			formData.append('lastname', registerFormData.lastname);
			formData.append('phone', registerFormData.phone);
			formData.append('address', registerFormData.address);
			formData.append('status', registerFormData.status);
			formData.append('role', registerFormData.role);
			formData.append('subscription_by', registerFormData.subscription_by);
			formData.append('level', registerFormData.level);
			formData.append('branch', registerFormData.branch);
			formData.append('passwrd', registerFormData.passwrd);

			// Awaited and checked: the receipt is the whole point of the form, so a
			// server that refused it must not leave the client seeing "تم بنجاح".
			const url = '/api/register';
			const response = await fetch(url, {
				method: 'POST',
				body: formData,
			});
			if (!response.ok) throw new Error(`Register failed: ${response.status}`);

			// Reset form
			setRegisterFormData({
				email: '',
				firstname: '',
				lastname: '',
				phone: '',
				address: 'NA',
				status: 'REGISTERED',
				role: 'USER',
				subscription_by: 'NA',
				level: '3 ثانوي',
				branch: 'آداب وفلسفة',
				passwrd: 'NA',
			});
			setPaymentReceivedContentFile(null);

			setRegisterBtnText('إرسال التسجيل');
			setIsStartRegister(false);
			setIsShowRegisterConfirmDialog(true);
		} catch (error) {
			console.error('Error: ', error);
			setRegisterBtnText('إرسال التسجيل');
			setIsStartRegister(false);
			setIsShowRegisterErrorDialog(true);

			// Reset form
			setRegisterFormData({
				email: '',
				firstname: '',
				lastname: '',
				phone: '',
				address: 'NA',
				status: 'REGISTERED',
				role: 'USER',
				subscription_by: 'NA',
				level: '3 ثانوي',
				branch: 'آداب وفلسفة',
				passwrd: 'NA',
			});
			setPaymentReceivedContentFile(null);
		}
	};

	return (
		<div className="flex min-h-screen items-center justify-center p-4" style={{ backgroundColor: '#e6e6b8' }}>
			<div className="w-full max-w-[650px]">
				<Link to="/" className="mb-8 flex items-center justify-center gap-3">
					<div className="flex h-10 w-10 shrink-0 items-center justify-center">
						<img src={cdnImage('jaber-alkhawater-logo.png', JaberAlkhawaterLogo)} alt="جبر الخواطر" className="text-primary-foreground" />
					</div>
					<span className="text-xl font-bold text-foreground sm:text-2xl">جبر الخواطر</span>
				</Link>

				<div className="rounded-2xl p-5 shadow-lg sm:p-10" style={{ backgroundColor: '#ffe600' }}>
					<h1 className="mb-2 text-center text-xl font-bold text-foreground sm:text-2xl">إنشاء حساب</h1>
					<p className="mb-6 text-center text-sm text-muted-foreground">سجل الآن وابدأ رحلة التفوق في دراستك التعليمية</p>
					<br></br>

					<form onSubmit={handleRegisterSubmit} className="space-y-4">
						<div className="flex flex-col gap-4 sm:flex-row">
							<div className="w-full min-w-0 space-y-2">
								<Label htmlFor="firstname" className="font-bold">
									الإسم
								</Label>
								<Input
									id="firstname"
									type="text"
									placeholder=""
									className="text-right"
									style={{ borderColor: 'green' }}
									value={registerFormData.firstname}
									onChange={(e) => setRegisterFormData({ ...registerFormData, firstname: e.target.value })}
									required
									autoFocus={true}
								/>
							</div>
							<div className="w-full min-w-0 space-y-2">
								<Label htmlFor="lastname" className="font-bold">
									اللقب
								</Label>
								<Input
									id="lastname"
									type="text"
									placeholder=""
									className="text-right"
									style={{ borderColor: 'green' }}
									value={registerFormData.lastname}
									onChange={(e) => setRegisterFormData({ ...registerFormData, lastname: e.target.value })}
									required
								/>
							</div>
						</div>

						<div className="flex flex-col gap-4 sm:flex-row">
							<div className="w-full min-w-0 space-y-2">
								<Label htmlFor="email" className="font-bold">
									البريد الإلكتروني
								</Label>
								<Input
									id="email"
									type="email"
									placeholder=""
									className="text-right"
									style={{ borderColor: 'green' }}
									value={registerFormData.email}
									onChange={(e) => setRegisterFormData({ ...registerFormData, email: e.target.value })}
									required
								/>
							</div>

							<div className="w-full min-w-0 space-y-2">
								<Label htmlFor="phone" className="font-bold">
									رقم الهاتف
								</Label>
								<Input
									id="phone"
									type="text"
									placeholder=""
									className="text-right"
									style={{ borderColor: 'green' }}
									value={registerFormData.phone}
									onChange={(e) => setRegisterFormData({ ...registerFormData, phone: e.target.value })}
									required
								/>
							</div>
						</div>

						<div className="flex flex-col space-y-2">
							<Label htmlFor="payment" className="font-bold">
								ارفع صورة وصل الدفع
							</Label>
							<div className="w-full p-2" style={{ borderWidth: 1, borderColor: 'green', borderRadius: 6 }}>
								<input
									id="payment_received"
									name="payment_received"
									type="file"
									onChange={handlePaymentReceivedContentChange}
									required
									className="block w-full max-w-full text-sm file:mr-3 file:cursor-pointer file:rounded file:border-0 file:bg-primary file:px-3 file:py-1 file:text-sm file:text-primary-foreground"
								/>
							</div>
						</div>
						<br />

						<div className="flex flex-col gap-4 sm:flex-row">
							<div className="w-full min-w-0 space-y-2">
								<Label className="font-bold">المستوى الدراسي</Label>
								<Select
									value={registerFormData.level}
									onValueChange={(value) => setRegisterFormData({ ...registerFormData, level: value })}
									dir="rtl">
									<SelectTrigger>
										<SelectValue placeholder="اختر المستوى" />
									</SelectTrigger>
									<SelectContent>
										<SelectItem value="1 ثانوي">السنة الأولى ثانوي</SelectItem>
										<SelectItem value="2 ثانوي">السنة الثانية ثانوي</SelectItem>
										<SelectItem value="3 ثانوي">السنة الثالثة ثانوي</SelectItem>
									</SelectContent>
								</Select>
							</div>

							<div className="w-full min-w-0 space-y-2">
								<Label className="font-bold">الشعبة</Label>
								<Select
									value={registerFormData.branch}
									onValueChange={(value) => setRegisterFormData({ ...registerFormData, branch: value })}
									dir="rtl">
									<SelectTrigger>
										<SelectValue placeholder="اختر الشعبة" />
									</SelectTrigger>
									<SelectContent>
										<SelectItem value="علوم تجريبية">علوم تجريبية</SelectItem>
										<SelectItem value="رياضيات">رياضيات</SelectItem>
										<SelectItem value="تقني رياضي">تقني رياضي</SelectItem>
										<SelectItem value="تسيير واقتصاد">تسيير واقتصاد</SelectItem>
										<SelectItem value="آداب وفلسفة">آداب وفلسفة</SelectItem>
									</SelectContent>
								</Select>
							</div>
						</div>
						<br />
						<br />

						<Button type="submit" className="w-full" size="lg" disabled={isStartRegister}>
							{registerBtnText}
						</Button>
					</form>

					<p className="mt-6 text-center text-sm text-muted-foreground">
						لديك حساب بالفعل؟{'  '}
						<Link to="/login" className="font-semibold text-primary hover:underline">
							تسجيل الدخول
						</Link>
					</p>
				</div>

				<p className="mt-4 text-center text-sm text-muted-foreground">
					<Link to="/" className="hover:text-primary">
						العودة إلى الصفحة الرئيسية
					</Link>
				</p>
			</div>

			{/* Show register confirm dialog */}
			<div dir="rtl">
				<Dialog open={isShowRegisterConfirmDialog} onOpenChange={setIsShowRegisterConfirmDialog}>
					<DialogContent className="w-[calc(100%-2rem)] max-w-md rounded-lg p-6 sm:p-8" style={{ minWidth: '220px', minHeight: '100px' }} dir="rtl">
						<DialogHeader>
							<DialogTitle></DialogTitle>
							<DialogDescription></DialogDescription>
						</DialogHeader>
						<div dir="rtl">
							<h2 className="mb-2 text-center font-bold" style={{ color: 'green' }}>
								تمت عملية التسجيل بنجاح
							</h2>
							<br />
							<div>سوف تتواصل معك ادارة المنصة من أجل اتمام العملية النهائية للتسجيل</div>
							<br />
						</div>
					</DialogContent>
				</Dialog>
			</div>

			{/* Show register error dialog */}
			<div dir="rtl">
				<Dialog open={isShowRegisterErrorDialog} onOpenChange={setIsShowRegisterErrorDialog}>
					<DialogContent className="w-[calc(100%-2rem)] max-w-md rounded-lg p-6 sm:p-8" style={{ minWidth: '220px', minHeight: '100px' }} dir="rtl">
						<DialogHeader>
							<DialogTitle></DialogTitle>
							<DialogDescription></DialogDescription>
						</DialogHeader>
						<div dir="rtl">
							<h2 className="mb-2 text-center font-bold" style={{ color: 'red' }}>
								حدث خطأ فني أثناء التسجيل
							</h2>
							<br />
							<div>يرجى التواصل مع ادارة المنصة</div>
							<br />
						</div>
					</DialogContent>
				</Dialog>
			</div>
		</div>
	);
};

export default RegisterComponent;
